<template>
  <header class="page-hero">
    <div class="page-hero__bg" :style="bgStyle" aria-hidden="true" />
    <div class="page-hero__scrim" aria-hidden="true" />
    <div class="page-hero__grain" aria-hidden="true" />
    <div class="page-hero__inner">
      <h1 class="page-hero__title">{{ title }}</h1>
      <p v-if="titleEn" class="page-hero__en">{{ titleEn }}</p>
    </div>
  </header>
</template>

<script>
/** 列表页顶栏大图：可换为自己的图，放到 public/banner-inner.jpg 或通过 image 传入 */
const DEFAULT_BG =
  'https://images.unsplash.com/photo-1507842217343-583bb7270b66?auto=format&fit=crop&w=2000&q=80'

export default {
  name: 'PageHeroBanner',
  props: {
    title: { type: String, required: true },
    titleEn: { type: String, default: '' },
    /** 绝对 URL 或 / 开头的站内路径，如 /banner-inner.jpg */
    image: { type: String, default: '' }
  },
  computed: {
    bgStyle() {
      const url = (this.image && String(this.image).trim()) || DEFAULT_BG
      return { backgroundImage: `url(${url})` }
    }
  }
}
</script>

<style scoped>
.page-hero {
  position: relative;
  min-height: 300px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
  color: #fff;
}

@media (min-width: 901px) {
  .page-hero {
    min-height: 320px;
  }
}

.page-hero__bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #0f172a;
}

.page-hero__scrim {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(
    180deg,
    rgba(15, 23, 42, 0.25) 0%,
    rgba(15, 23, 42, 0.72) 100%
  );
}

.page-hero__grain {
  position: absolute;
  inset: 0;
  z-index: 1;
  opacity: 0.07;
  pointer-events: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 160 160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.45'/%3E%3C/svg%3E");
}

.page-hero__inner {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 88px 20px 40px;
  text-align: center;
  box-sizing: border-box;
}

.page-hero__title {
  font-size: clamp(28px, 4vw, 42px);
  font-weight: 700;
  letter-spacing: 0.12em;
  margin: 0 0 10px;
  text-shadow: 0 2px 28px rgba(0, 0, 0, 0.5);
}

.page-hero__en {
  margin: 0;
  font-size: 13px;
  letter-spacing: 0.38em;
  color: #bae6fd;
  font-weight: 500;
  text-shadow: 0 1px 14px rgba(0, 0, 0, 0.45);
}

@media (max-width: 900px) {
  .page-hero__inner {
    padding-top: 76px;
    padding-bottom: 32px;
  }
}
</style>
